
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class validationErrorModal extends Vue {

    @Prop() errors: { [key: string]: [] }[];

}
